import React, { useContext } from "react";

import { IconButton, Tooltip } from "@material-ui/core";
import { EscalatorWarning } from "@mui/icons-material";
import { BrandContext } from "../../../contexts/BrandContext";

export default function UmStatusIcon(props){

    
    const brandContext = useContext(BrandContext);

    const {
        textContent:{
            unacSet='',
            walkToCheckinSet='',
        }
    } = brandContext;

    const {
        stb,
        onClick
    } = props;

    const {
        walkToCheckin='',
        unac=''
    } = stb;

    let title = '';
    if(unac){
        title = unacSet;
    }
    if(walkToCheckin){
        title = walkToCheckinSet;
    }

    if(title){
        return (
            <Tooltip title={title}>
                <IconButton size="small" className="iconBooked" onClick={onClick}>
                    {unac &&
                        <EscalatorWarning className="iconBooked"/>
                    }
                    {walkToCheckin &&
                        <EscalatorWarning className="iconBooked"/>
                    }
                </IconButton>
            </Tooltip>
        );
    }
    return null;
}